import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "row", "templateSelect", "variablesSection", "variableFields"]

  connect() {
    this.variableIndex = this.hasRowTarget ? this.rowTargets.length : 0
  }

  addVariable() {
    const index = this.variableIndex++
    const types = ["string", "currency", "percentage", "integer", "date"]
    const typeOptions = types.map(t => `<option value="${t}">${t.charAt(0).toUpperCase() + t.slice(1)}</option>`).join("")

    const html = `
      <div class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg" data-template-variables-target="row">
        <div class="flex-1">
          <input type="text" name="agreement_template[template_variables][${index}][name]"
                 placeholder="variable_name" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="flex-1">
          <input type="text" name="agreement_template[template_variables][${index}][label]"
                 placeholder="Display Label" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="w-36">
          <select name="agreement_template[template_variables][${index}][type]"
                  class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
            ${typeOptions}
          </select>
        </div>
        <div class="w-32">
          <input type="text" name="agreement_template[template_variables][${index}][default]"
                 placeholder="Default" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <button type="button" data-action="click->template-variables#removeVariable"
                class="text-red-400 hover:text-red-600 p-1">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    `

    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  removeVariable(event) {
    const row = event.target.closest('[data-template-variables-target="row"]')
    if (row) row.remove()
  }

  loadTemplate() {
    if (!this.hasTemplateSelectTarget || !this.hasVariableFieldsTarget) return

    const select = this.templateSelectTarget
    const option = select.options[select.selectedIndex]

    if (!option || !option.value) {
      this.variableFieldsTarget.innerHTML = '<p class="text-sm text-gray-400 italic">Select a template above to see the fillable fields.</p>'
      return
    }

    const variables = JSON.parse(option.dataset.variables || "[]")

    if (variables.length === 0) {
      this.variableFieldsTarget.innerHTML = '<p class="text-sm text-gray-400 italic">This template has no fillable variables.</p>'
      return
    }

    const fieldsHtml = variables.map(v => this.buildVariableField(v)).join("")
    this.variableFieldsTarget.innerHTML = fieldsHtml
  }

  buildVariableField(variable) {
    const label = variable.label || variable.name.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())
    const name = `agreement[variable_values][${variable.name}]`
    const defaultVal = variable.default || ""

    let input = ""
    switch (variable.type) {
      case "currency":
        input = `
          <div class="mt-1 relative rounded-md shadow-sm">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span class="text-gray-500 sm:text-sm">$</span>
            </div>
            <input type="number" step="0.01" name="${name}" value="${defaultVal}"
                   class="pl-7 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          </div>`
        break
      case "percentage":
        input = `
          <div class="mt-1 relative rounded-md shadow-sm">
            <input type="number" step="0.1" min="0" max="100" name="${name}" value="${defaultVal}"
                   class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
            <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              <span class="text-gray-500 sm:text-sm">%</span>
            </div>
          </div>`
        break
      case "integer":
        input = `<input type="number" name="${name}" value="${defaultVal}"
                        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">`
        break
      case "date":
        input = `<input type="date" name="${name}" value="${defaultVal}"
                        class="mt-1 block w-48 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">`
        break
      default:
        input = `<input type="text" name="${name}" value="${defaultVal}"
                        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">`
    }

    return `<div><label class="block text-sm font-medium text-gray-700">${label}</label>${input}</div>`
  }
}
